const PERCENTAGE_DIVISOR = 100;

export const applyDiscount = (price: number, discountAmount: number): number => {
  if (!discountAmount) {
    return price;
  }

  return price - (price * discountAmount) / PERCENTAGE_DIVISOR;
};
